// extracted by mini-css-extract-plugin
module.exports = {"--no-animation":"jg-homepage-29hll","waveAction":"jg-homepage-2E81r","waveEnd":"jg-homepage-1dAbb"};